<template>
  <div class="space-y-6">
    <form class="container grid grid-cols-2 gap-6" autocomplete="off" @submit.prevent="() => {}">
      <input autocomplete="false" name="hidden" type="text" style="display: none" />
      <!-- PAR -->
      <div class="space-y-6">
        <symbol-pair-component
          :symbolList="symbolList"
          :operationTypes="operationTypes"
          @property-change="changeProperty"
          :editInfo="editInfo"
        />
      </div>

      <!-- REGRAS DE EXECUÇÃO -->
      <div>
        <rules-component :options="methods" :isPublicOrder="!!getData.isPublicOrder" :editInfo="editInfo" />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ontickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";
import RulesComponent from "./rules.component.vue";
import SymbolPairComponent from "./symbol-pair.component.vue";

export default {
  components: {
    ontickEditableSelectComponent,
    SymbolPairComponent,
    RulesComponent,
  },

  props: {
    orderInfo: {
      type: Object,
    },
    editInfo: {
      type: Object,
    },
  },

  data() {
    return {
      operationTypes: [
        {
          label: "Compra",
          value: "BUY",
        },
        {
          label: "Venda",
          value: "SELL",
        },
      ],
      methods: [
        {
          label: "Fator",
          value: "FATOR",
        },
        {
          label: "Diferença",
          value: "DIFERENÇA",
        },
        {
          label: "Função linear",
          value: "FUNÇÃO LINEAR",
        },
      ],
    };
  },

  computed: {
    ...mapGetters({ getData: "longShort/getData" }),
    symbolList() {
      return "PETR4, VALE3, CMIN3, BOVA11, WINFUT, WDOFUT".split(", ").map((item) => {
        return {
          label: item,
          value: item,
        };
      });
    },
    isEditing() {
      return !!this.$route.params.alg_ord_id;
    },
  },

  methods: {
    changeProperty(val) {
      // console.log(val);
      this.data[val.prop] = val.value;
    },
    edit() {
      ["name", "description"].forEach((item) => {
        this.$emit("updateOrderInfo", {
          prop: `${item}.disabled`,
          value: !this.orderInfo[item].disabled,
        });
      });
    },
  },
};
</script>

<style lang="scss">
@import "../style/date-time-picker.scss";
</style>
<style lang="scss" scoped>
.input {
  @apply bg-ontick-carbon-500 disabled:bg-ontick-steel-500 h-10 w-full rounded border-0 px-2 text-sm shadow disabled:cursor-not-allowed disabled:border;
}
.edit-button {
  @apply text-ontick-blue-600 absolute right-2;
}
</style>
